
import {useState, useEffect } from 'react';
import { useSelector,useDispatch } from 'react-redux';
import { visualizerActions } from "../../store";
import ProductList from '../ProductList/ProductList';
import DropdownFilter from "../DropdownFilter/DropdownFilter";
import ColorDropdown from "../ColorDropdown/ColorDropdown";
import ProductSearch from "../ProductSearch/ProductSearch";
import FlooringInstalliationMethods from "../FlooringInstalliationMethods/FlooringInstalliationMethods";
import styles from './FlooringSubMenu.module.css';
import brush from './assets/brush.svg';
import pattern from './assets/pattern.svg';
import defaultColorWayThumb from './assets/thumb.svg';
import { uiActions } from '../../store';
export default function FlooringSubMenu({activeParentMenuTab,colorwaySeriesIds}) {
    const dispatch = useDispatch();
    const compareData = useSelector(state => state.visualizer.compareData);
    const appliedDropdownFilters = useSelector(state => state.visualizer.productDropdownFilters);
    const [colorwaySearchValue, setColorwaySearchValue] = useState(""); 
    const [customizeSearchValue, setCustomizeSearchValue] = useState("");

    const dropdownFilters = useSelector((state) => state.visualizer.productDropdownFilters);
    const[activeSubMenuTab, setActiveSubMenuTab] = useState('Colorway');
    const activeFlooringSubMenuTab = useSelector((state) => state.visualizer.activeFlooringSubMenuTab);
    const activeSurface = useSelector(state => state.visualizer.activeSurface);
    const appliedProducts = useSelector(state => state.visualizer.appliedProducts);
    const activeFlooringSeriesIds = useSelector(state => state.visualizer.activeFlooringSeriesIds);
    const selectedProduct = appliedProducts?.[activeSurface?.location ?? 'chamViz']?.[activeSurface?.name] ?? null;
    const masterData = useSelector(s => s.visualizer.productDataBySeries) || {};
    const colorData  = masterData['8394']; 
    const[activeColorIndex, setActiveColorIndex] = useState(-1);
    const[activeRgbArray, setActiveRgbArray] = useState([]);
    const[activeSelsArray, setActiveSelsArray] = useState([]);

    const[collectionFilterColumnName, setCollectionFilterColumnName] = useState();
    const[styleFilterColumnName, setStyleFilterColumnName] = useState();
    
    // Helper to build filterBy object for cascading dropdowns
    const getCollectionFilter = () => {
        if (!collectionFilterColumnName) return null;
        const collectionValue = appliedDropdownFilters[collectionFilterColumnName];
        if (collectionValue === undefined || collectionValue === -1 || collectionValue === '-1') return null;
        return { [collectionFilterColumnName]: collectionValue };
    };
   

    useEffect(() => {
        let collectionColName;
        let styleColName;

        switch(activeFlooringSubMenuTab){
            case 'Modular Carpet':
                collectionColName = 'manufacturerSeriesName';
                styleColName = 'style';
                break
            case 'Broadloom Carpet':
                collectionColName = 'manufacturerSeriesName';
                styleColName = 'color';
                break;    
            case 'LVT':
                collectionColName = 'name';
                styleColName = 'color';
                break;
            case 'Resilient Sheet':
                collectionColName = 'name';
                styleColName = 'warranty';
                break;
        }

        setCollectionFilterColumnName(collectionColName);
        setStyleFilterColumnName(styleColName);
        
    }, [activeFlooringSubMenuTab]); 

    const [colorwayThumb, setColorwayThumb] = useState(defaultColorWayThumb);
    
    useEffect(() => {
        if (
            Array.isArray(activeFlooringSeriesIds) &&
            selectedProduct?.colorway &&
            activeFlooringSeriesIds.includes(selectedProduct.colorway.seriesID)
        ) {
            setColorwayThumb(
            `https://renderfarm2.chameleonpower.com/proxy/getImage.ashx?spec=${encodeURIComponent(
                selectedProduct.colorway.specifier
            )}&type=prod&extra=(focus=500)&Size=250`
            );
        } else {
            setColorwayThumb(defaultColorWayThumb);
        }
    }, [activeFlooringSeriesIds, selectedProduct]);


    useEffect(() => {
        if(!selectedProduct)
            return;

        const sels = [];
        const rgbArray = (selectedProduct.selStrings || [])
        .map(sel => {
            // get the number inside the parentheses
            const id = /\((\d+)\)/.exec(sel)?.[1];
            sels.push(id);
            // handle string or numeric keys in colorData
            const spec = id ? (colorData?.[id] ?? colorData?.[Number(id)])?.specifier : null;
            const m = spec?.match(/RGB\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*\)/i);
            return m ? `rgb(${m[1]}, ${m[2]}, ${m[3]})` : null;
        })
        .filter(Boolean);

        setActiveRgbArray(rgbArray);
        setActiveSelsArray(sels);
        
    }, [selectedProduct]); 

    useEffect(() => {
        
        if(!selectedProduct || !activeSurface || activeSurface.name.toLowerCase().includes('wall') )
            return;

       let sel;
       let product = selectedProduct.colorway;

       switch(product.seriesID){
        case 1:
            //customizible
             sel = `${selectedProduct.install}(${product.id}(${selectedProduct.selStrings.join()}))`;
            break;
        case 8639:
            //Modular Carpet
            sel = `${selectedProduct.install}(${product.id},{90})`;
            break;
        case 9743:
            //Broadloom Carpet
            sel = `${selectedProduct.install}(${product.id},{90})`;
            break;
        case 8644:
        case 8643:
            //heterogeneoussheet
            //homogeneoussheet
            sel = `${product.id}`;
            break;
        case 8645:
            //LVT
            sel = `${product.id}(254252)`;
            break;
       }
      

        document.getElementById(compareData.side).applyByFilter('', '', function (newSel) {
            if (activeSurface?.name === this.name) {
                if(sel != this.sel){
                     console.log('applying this sel',sel)
                    dispatch(uiActions.setVizLoading(true));
                    return sel;
                }else{
                    console.log('sel is the same...')
                    console.log(sel+' == '+ this.sel)
                }
            }
        });
        
    }, [selectedProduct,appliedProducts]); 
    

    function getRgbFromSpec(spec) {
        const m = /RGB\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*\)/i.exec(spec || '');
        return m ? `rgb(${m[1]}, ${m[2]}, ${m[3]})` : null;
    }


    const handleSubMenuTabSelect = (menuTab) => () => {
        setActiveSubMenuTab(menuTab);
    };

    const handleFloorProductSelect = (product) => {
       if(!activeSurface){
            alert('Choose a surface first');
            return;
        }

        if(activeSurface.name.toLowerCase().includes('wall')){
            alert('Please choose a compatible surface.');
            return;
        }

        setActiveColorIndex(-1);
        const defaultInstall = 5983716;

        const selStrings = Array.from(
            (product.displayName ?? '').matchAll(/(\d+)\(\s*(\d+(?:\s*,\s*\d+)*)\s*\)/g)
        ).flatMap((m) => {
            const prefix = m[1];                   // e.g. "4"
            const inner  = m[2];                   // e.g. "4701893,4701897"
            return inner.split(/\s*,\s*/).map(id => `${prefix}(${id})`);
        });
    
        const side = compareData.active ? compareData.side : 'chamViz';
        dispatch(visualizerActions.setCompareData({ key: side, value: product }));

        dispatch(visualizerActions.setAppliedProduct({
            location: side,
            surface: activeSurface.name,
            data: {
                colorway: product,
                selStrings: selStrings,
                size: null,
                install: defaultInstall,
            },
        }));
    };

    const handleDropdownFilterChange = (e) => {
        const { name, value } = e.target;
        dispatch(visualizerActions.setproductDropdownFilter({
            [name]: value,
        }));
        setColorwaySearchValue('');
        dispatch(visualizerActions.clearProductSearchFilters());

    };

    const handlecolorFilterSelect = (color) => {
        dispatch(visualizerActions.setproductDropdownFilter({
            ['description']: color,
        }));
        setColorwaySearchValue('');
        dispatch(visualizerActions.clearProductSearchFilters());

    };


    const handleColorSelect = (index) => {
        console.log('index',index)
        setActiveColorIndex(index);
    };

    const handleFloorProductInstall = (install) => {
        

        dispatch(visualizerActions.updateAppliedProductDataVal({
            location: activeSurface.location,
            surface:  activeSurface.name,
            key:      'install',
            value:    install,
        }));

    };


    const handleColorSwap = (product) => {
        const rgb = getRgbFromSpec(product.specifier);
        
        

        setActiveRgbArray(prev => {
            // guard bad index or empty array
            if (activeColorIndex == null || activeColorIndex < 0 || activeColorIndex >= prev.length) return prev;

            const next = [...prev];
            next[activeColorIndex] = rgb; // replace the selected color
            return next;
        });

        const newSelStrings = [...selectedProduct.selStrings];
        newSelStrings[activeColorIndex] = `4(${product.id})`; // or String(product.id) if you store strings

        // 4) dispatch the new array
        dispatch(visualizerActions.updateAppliedProductDataVal({
            location: activeSurface.location,
            surface:  activeSurface.name,
            key:      'selStrings',
            value:    newSelStrings,
        }));

    };

  
    const renderActiveMenuTab = () => {
        switch (activeSubMenuTab) {
          case 'Colorway':
            return (
              <div className={styles.broadFilters}>
                <div>
                    <ProductSearch
                        name="product search"
                        columns="color,name,manufacturerSeriesName,style,seriesName"
                        placeholder="Search by collection, style or color"
                        value={colorwaySearchValue}
                        onChange={(e) => setColorwaySearchValue(e.target.value)}
                    />
                </div>
                <div>
                    <DropdownFilter
                        handleSelect={handleDropdownFilterChange}
                        seriesIds={colorwaySeriesIds}
                        label="Collections"
                        column={collectionFilterColumnName}
                        value={appliedDropdownFilters[collectionFilterColumnName] ?? -1}
                    />

                    {activeParentMenuTab === 'Modular Carpet' && (
                        <>
                            <DropdownFilter
                            handleSelect={handleDropdownFilterChange}
                            seriesIds={colorwaySeriesIds}
                            label="Styles"
                            column={styleFilterColumnName}
                            value={appliedDropdownFilters[styleFilterColumnName] ?? -1}
                            filterBy={getCollectionFilter()}
                        />
                        <ColorDropdown
                            handleColorDropdownSelect={handleDropdownFilterChange}
                            seriesIds={colorwaySeriesIds}
                            column="description"
                            label="Colors"
                            value={appliedDropdownFilters['description'] ?? -1}
                            filterBy={getCollectionFilter()}
                        />
                        </>
                    )}

                    {activeParentMenuTab === 'Resilient Sheet' && (
                        <DropdownFilter
                            handleSelect={handleDropdownFilterChange}
                            seriesIds={[8644,8643]}
                            label="Types"
                            column="seriesName"
                            value={appliedDropdownFilters['seriesName'] ?? -1}
                            filterBy={getCollectionFilter()}
                            className={styles.fullWidth}
                        />
                    )}
                    
                </div>
                <ProductList
                    seriesIds={colorwaySeriesIds}
                    thumbSize={250}
                    handleSelect={handleFloorProductSelect}
                    dropdownFilters={dropdownFilters}
                    searchValue={colorwaySearchValue}
                    searchColumns="color,name,manufacturerSeriesName,style"
                    collectionFilterColumnName={collectionFilterColumnName}
                />
              </div>
            );
        case 'Customize':
            return (<>
                    <p className={styles.heading}>Colors in the Colorway</p>
                    <p>Select on and choose a new color to recolor the patter</p>
                    <div className={styles.topThumbs}>
                        <ul>
                            {activeRgbArray.length ? activeRgbArray.map((cssRgb, i) => (
                                <li
                                
                                    style={{ backgroundColor: cssRgb }}
                                    key={i}
                                    onClick={() => { setActiveColorIndex(i); handleColorSelect(i); }}
                                    className={`${styles.swatch} ${i === activeColorIndex ? styles.active : ''}`}
                                    role="option"
                                    aria-selected={i === activeColorIndex}
                                >
                                   <span> {colorData[ activeSelsArray[i] ].name}</span>
                                </li>
                            )) : <small>No colors</small>}
                        </ul>
                    </div>
                    <div className={styles.inputCustomize}>
                        <ProductSearch
                            name="product search"
                            columns="color,name"
                            placeholder="Search by collection, style or color"
                            value={customizeSearchValue}
                            onChange={(e) => setCustomizeSearchValue(e.target.value)}
                        />
                        <ProductList
                            seriesIds="8394"
                            thumbSize={250}
                            handleSelect={handleColorSwap}
                            searchValue={customizeSearchValue}
                        />
                    </div>


                </>
            )

        case 'Size':
            return (<>
                    <ProductList
                        seriesIds="7973"
                        thumbSize={250}
                        handleSelect={handleFloorProductSelect}
                        searchValue={customizeSearchValue}
                    />
                </>
            )
            
          case 'Install Patterns':
            return (
              <FlooringInstalliationMethods
                selectedProduct={selectedProduct?.colorway ?? null}
                handleFloorProductInstall={handleFloorProductInstall}
              />
            );
          default:
            return null;
        }
      };

      const renderCustomizeTabs = () => {
        {/* <>
            <li onClick={handleSubMenuTabSelect('Colorway')}>
                <img src={colorwayThumb} alt="Colorway" /><span>Colorway</span>
            </li>
             <li onClick={handleSubMenuTabSelect('Customize')}>
                <img src={brush} alt="Customize" /><span>Customize</span>
            </li>
            <li onClick={handleSubMenuTabSelect('Install Patterns')}>
                <img src={pattern} alt="Install Patterns" /><span>Install Patterns</span>
            </li>
           
        </> */}
        if (activeParentMenuTab === 'Modular Carpet') {
            return (
            <>
                <li onClick={handleSubMenuTabSelect('Colorway')}>
                    <img src={colorwayThumb} alt="Colorway" /><span>Colorway</span>
                </li>
                <li onClick={handleSubMenuTabSelect('Install Patterns')}>
                    <img src={pattern} alt="Install Patterns" /><span>Install Patterns</span>
                </li>
            </>
            );
        } else if (activeParentMenuTab === 'Broadloom Carpet') {
            return (<></>);
        }
        // default
        return (<></>);
      };
    
    return (
        <>
            <ul className={styles.broadDiv}>
                {renderCustomizeTabs()}
            </ul>

            {renderActiveMenuTab()}
        </>
    );



}